import { defineStore } from "pinia";
import { getDatatypesMapper } from "@/components/Datatypes";
import {} from "@/components/Datatypes/model";
import { rethrowSimple } from "@/utils/simple-error";
export const useDatatypesMapperStore = defineStore("datatypesMapperStore", {
    state: () => ({
        datatypesMapper: null,
        loading: false,
    }),
    actions: {
        async createMapper() {
            if (!this.loading && !this.datatypesMapper) {
                this.loading = true;
                try {
                    this.datatypesMapper = await getDatatypesMapper(false);
                    this.loading = false;
                }
                catch (error) {
                    this.loading = false;
                    rethrowSimple(error);
                }
            }
        },
    },
});
